import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { SideNav } from './SideNav';
import { Breadcrumbs } from './Breadcrumbs';
import { Loading } from '@/components/Loading';
import { RouteErrorBoundary } from './RouteErrorBoundary';

/** ヘッダー＋サイドナビ＋本文（/years/:year 配下の共通枠） */
export function AppLayout() {
  const location = useLocation();
  return (
    <div className="bs-shell">
      <a href="#main" className="bs-skip">
        本文へ移動
      </a>
      <AppHeader />
      <div className="bs-shell__body">
        <SideNav />
        <main id="main" className="bs-main" tabIndex={-1}>
          <Breadcrumbs />
          <RouteErrorBoundary resetKey={location.pathname}>
            <Suspense fallback={<Loading block />}>
              <Outlet />
            </Suspense>
          </RouteErrorBoundary>
        </main>
      </div>
    </div>
  );
}
